export const convertDateTimeStringToLocate = (dateTimeString: string) => {
  const utcDate = new Date(dateTimeString);
  return new Intl.DateTimeFormat("nl-NL", {
    timeZone: "Europe/Amsterdam",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
    .format(utcDate)
    .replace(/\//g, "-");
};

export const formatDateForServer = (
  date: Date | null | undefined | string,
): string | null => {
  if (!date) {
    return null;
  }

  let dateObj: Date;

  if (typeof date === "string") {
    // If it's already a string, check if it's in YYYY-MM-DD format
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date; // Already in correct format
    }
    dateObj = new Date(date);
  } else {
    dateObj = date;
  }

  if (!dateObj || isNaN(dateObj.getTime())) {
    return null;
  }

  // Format manually using getFullYear, getMonth, getDate to avoid timezone issues
  // These methods use local time, which is what we want for date-only values
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
